<template>
  <!-- Global notification live region, render this permanently at the end of the document -->
  <div aria-live="assertive" class="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start" style="z-index: 10000;">
    <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
      <!-- Notification panel, dynamically insert this into the live region when it needs to be displayed -->
      <transition v-for="(message, idx) in notifications" :key="`ui-notification-${idx}`"
                  :class="{'bg-green-50': isSuccess(message), 'bg-red-50': isError(message), 'bg-yellow-50': isWarning(message), 'bg-blue-50': isInfo(message)}"
                  enter-active-class="transform ease-out duration-300 transition"
                  enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                  enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
                  leave-active-class="transition ease-in duration-100"
                  leave-from-class="opacity-100"
                  leave-to-class="opacity-0">
        <div class="max-w-sm w-full  shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
          <div class="p-4">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <CheckCircleIcon v-if="isSuccess(message)" class="h-6 w-6 text-green-500 font-semibold" aria-hidden="true"/>
                <ExclamationIcon v-else-if="isWarning(message)" class="h-6 w-6 text-yellow-500 font-semibold" aria-hidden="true"/>
                <XCircleIcon v-else-if="isError(message)" class="h-6 w-6 text-red-500 font-semibold" aria-hidden="true"/>
                <InformationCircleIcon v-else class="h-6 w-6 text-blue-500 font-semibold" aria-hidden="true"/>
              </div>
              <div :class="{'text-green-700': isSuccess(message), 'text-red-700': isError(message), 'text-yellow-700': isWarning(message), 'text-blue-700': isInfo(message)}"
                   class="ml-3 w-0 flex-1 pt-0.5">
                <p v-html="message.title"
                   :class="{'font-semibold': message.body !== null}"
                   class="text-sm">
                </p>
                <p v-if="message.body !== null" class="mt-1 text-sm" v-html="message.body"></p>
              </div>
              <div class="ml-4 flex-shrink-0 flex">
                <button @click.prevent.stop="removeNotification(message)"
                        :class="{'bg-green-50': isSuccess(message), 'bg-red-50': isError(message), 'bg-yellow-50': isWarning(message), 'bg-blue-50': isInfo(message)}"
                        class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500">
                  <span class="sr-only">Close</span>
                  <XIcon class="h-5 w-5" aria-hidden="true"/>
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import {CheckCircleIcon, ExclamationIcon, InformationCircleIcon, XCircleIcon} from '@heroicons/vue/outline'
import {XIcon} from '@heroicons/vue/solid'
import {mapMutations, mapState} from "vuex";

export default {
  name: "uiNotification",
  components: {
    CheckCircleIcon, ExclamationIcon, XCircleIcon, InformationCircleIcon,
    XIcon,
  },
  methods: {
    isSuccess(message) {
      return message.type === 'success';
    },
    isInfo(message) {
      return message.type === 'info';
    },
    isError(message) {
      return message.type === 'error';
    },
    isWarning(message) {
      return message.type === 'warning';
    },
    ...mapMutations({
      removeNotification: 'removeNotification',
    }),

  },
  computed: {
    notifications() {
      return this.$store.getters.notifications;
    }
  }
}
</script>